import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ForWhoSection() {
  const isForYou = ['Eres mamá ocupada', 'Trabajas o llevas muchas responsabilidades', 'Te sientes saturada mentalmente', 'Quieres organizarte sin métodos extremos', 'Necesitas algo simple y realista'];
  const notForYou = ['Buscas productividad extrema', 'Quieres rutinas perfectas', 'No estás dispuesta a aplicar nada', 'Esperas resultados sin dedicar al menos 10 minutos al día'];
  return <section className="py-20 bg-beige md:py-32" data-id="element-13">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" data-id="element-14">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="max-w-5xl mx-auto" data-id="element-15">
          <motion.h2 variants={itemVariants} className="mb-16 text-3xl font-bold text-center md:text-4xl text-charcoal font-playfair" data-id="element-16">
            ¿Este sistema es para ti?
          </motion.h2>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-2" data-id="element-17">
            {/* Is For You */}
            <motion.div variants={itemVariants} className="p-8 bg-white md:p-10 rounded-3xl shadow-sm border border-sage-light/40" data-id="element-18">
              <div className="flex items-center justify-center w-16 h-16 mb-8 rounded-full bg-warm-green/10" data-id="element-19">
                <CheckIcon className="w-8 h-8 text-warm-green" data-id="element-20" />
              </div>
              <h3 className="mb-6 text-2xl font-bold text-charcoal font-playfair" data-id="element-21">
                Este sistema es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-22">
                {isForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-23">
                    <CheckIcon className="w-6 h-6 mr-3 text-warm-green shrink-0" data-id="element-24" />
                    <span className="text-lg text-charcoal/80" data-id="element-25">{item}</span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Not For You */}
            <motion.div variants={itemVariants} className="p-8 bg-white md:p-10 rounded-3xl shadow-sm border border-red-100" data-id="element-26">
              <div className="flex items-center justify-center w-16 h-16 mb-8 rounded-full bg-red-50" data-id="element-27">
                <XIcon className="w-8 h-8 text-red-400" data-id="element-28" />
              </div>
              <h3 className="mb-6 text-2xl font-bold text-charcoal font-playfair" data-id="element-29">
                Este sistema NO es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-30">
                {notForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-31">
                    <XIcon className="w-6 h-6 mr-3 text-red-400 shrink-0" data-id="element-32" />
                    <span className="text-lg text-charcoal/80" data-id="element-33">{item}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}